import React from "react";
import "./PrivacyPolicy.css";
import Footer from "../Footer/Footer";

const PrivacyPolicy = () => {
  return (
    <>
      <div className="privacy-policy-container">
        <div className="privacy-policy-content">
          <h1 className="title">PRIVACY POLICY</h1>

          <p>
            <em>
              Disclaimer: The Company can modify this Policy unilaterally at any
              time without notice. Modification may be necessary to maintain
              compliance with applicable laws and regulations or accommodate
              organizational changes within the Company. Please keep visiting
              this page regularly to take note of any changes we make. If you do
              not agree with any part of this Policy, please stop using our
              Platform immediately.
            </em>
          </p>

          <p>
            The website – www.gettrendy.in ("Website"), the mobile application
            ("App"), and the mobile site ("Msite") (together referred to as the
            "Platform") are made available by Example Company ("Company" or
            "we"). This Policy demonstrates our firm commitment to protecting
            the information you submit while using our Platform.
          </p>

          <p>
            This Policy incorporates, and includes our Terms of Service
            ("Terms").
          </p>

          <p>
            By using the Platform (or even just browsing the Platform), you
            expressly consent to our use and disclosure of your personal
            information in accordance with this Privacy Policy.
          </p>

          <h5>
            A. What kind of personal information do we collect from you and when
            is it collected?
          </h5>

          <ol>
            <li>
              <strong>
                Information shared during registration and account creation:
              </strong>{" "}
              In order to avail of the Products and Offers, you will be required
              to register as a user using your phone number. For ordering
              Products, you will be required to provide your name, phone number,
              email ID, address, and pin code.
            </li>
            <li>
              <strong>Information from visitors and for participation:</strong>{" "}
              Visitors to our Platform may choose to submit their name, email
              address, and/or other information to learn more about our
              Products, Offers, and participate in surveys or events.
            </li>
            <li>
              <strong>Financial and KYC Information:</strong> Information
              including credit/debit card number, billing address, payment
              instrument details, etc. will be collected securely through our
              payment systems.
            </li>
            <li>
              <strong>Feedback Data and Other Data:</strong> Includes data
              collected from customer service calls or user feedback submissions
              on the platform.
            </li>
            <li>
              <strong>Information about other people:</strong> For some
              services, you may provide us with third-party information (such as
              names, emails).
            </li>
            <li>
              <strong>Usage Data:</strong> Collected automatically when you use
              our Platform, such as device information and interaction
              statistics.
            </li>
            <li>
              <strong>Device data:</strong> We collect data about the devices
              used to access our Platform, including the device IP address,
              unique device identifiers, advertising identifiers, serial
              numbers, device motion data, and mobile network data.
            </li>
            <li>
              <strong> Data collected through cookies:</strong>In simple terms,
              “cookies” are data collectors on websites. Cookies usually collect
              information regarding user settings such as language and special
              preferences. They also collect other miscellaneous information
              such as the time you spend on our Platform. Information collected
              through cookies is used to analyse how you interact with our
              website, how well you respond to marketing promotions, and to make
              your shopping experience safer. You are free to disable our
              cookies on your browser, but that may prevent you from accessing
              all the features of our Platform. Disabling our cookies may also
              require you to re-enter your account (in the event you have one)
              password over and over.
            </li>
            <li>
              <strong>Information collected through advertisements:</strong> Our
              Platform may use third party advertising companies to serve ads
              when you visit our Platform. The data regarding the way you
              interact with these ads is also collected, analysed and stored by
              us. This information allows ad networks to, among other things,
              deliver targeted advertisements that they believe will be of most
              interest to you. This Policy does not cover the use of cookies by
              any such advertisers.
            </li>
          </ol>

          <h5>B. How do we use your information?</h5>
          <ol>
            <li>
              Your personal information may be used for Company’s legitimate
              business interests in connection with your use of the Platform,
              including your registration, confirmation of your order, your
              delivery information, response to user inquiries and fulfil user
              requests, completion of transactions, providing customer service,
              sending administrative information, and to personalize user
              experience with the Platform. We may use this information to
              better understand our users in general and to improve the content
              and functionality of the Platform. We may use information to
              investigate and prosecute potential breaches of Company security
              or license agreements.
            </li>
            <li>
              From time to time, we may use your email address to send you
              information and keep you informed about the Products and Offers in
              which you might be interested. Your contact information may also
              be used to reach you regarding issues concerning your use of our
              Platform, including changes to this Policy.
            </li>
            <li>
              When you provide us with personal information about other people,
              (for example, you may provide us with a name and address for a
              merchandise gift recipient), we use that information for the
              purposes of processing the delivery and, in some cases, to
              communicate with the intended recipient with information
              pertaining to the status of the delivery. We rely on you to obtain
              the intended recipient's consent to our use of their personal
              information for these limited purposes.
            </li>
            <li>
              The financial and KYC information collected by Paytm and M Swipe
              is used for facilitating payment. If they have trouble processing
              an order, they may contact you by e-mail.
            </li>
            <li>
              We may occasionally contact you with our updates, newsletters,
              greetings, events and seminars that we hold, which we refer to as
              Marketing Communications. Further, we may use your personal
              information to respond to your inquiry or process a recruitment
              request application form you have consented to and completed on
              our Platform.
            </li>
          </ol>

          <h5>C. Do we share your personal information with third parties?</h5>
          <ol>
            <li>
              We do not sell the personal information of our customers to
              others. We also do not share such information with third party
              business entities for their marketing or advertising purposes,
              unless you explicitly allow us to do so.
            </li>
            <li>
              In certain cases, it is necessary for us to share your information
              with third parties. Such third parties may be:
              <ul>
                <li>
                  <strong>Third party service providers:</strong> Our business
                  operations involve many third-party organisations and
                  individuals in the performance of our functions. We may
                  disclose to third party service providers certain personally
                  identifiable information such as name, member ID, email,
                  mobile number, address or the information we collect from your
                  access and use of our Platform, including device information,
                  location and network carrier. Further, these third party
                  service providers may use cookies on our behalf and may
                  receive information about your browsing and buying activity.
                  This information is shared with third party service providers
                  so that we can personalize the Platform for you, perform
                  behavioural analytics and understand consumer patterns for the
                  Platform. This information is further shared with the logistic
                  companies and payment service providers for facilitating the
                  delivery of Products and payment on the Platform. <br />
                  We contract with third parties to serve ads on our behalf
                  across the internet and sometimes on our Platform. They may
                  collect anonymous information about your visits and your
                  interaction with our Platform. They may also use information
                  about your visits to target advertisements for goods and
                  services. This anonymous information is collected through the
                  use of a pixel tag, which is an industry standard technology
                  used by most major websites. No personally identifiable
                  information is collected or used in this process.
                </li>
                <li>
                  <strong>Government/Law enforcement:</strong> Your personal
                  information may be disclosed to governmental authorities or
                  law enforcement in good faith that such disclosure is
                  necessary to prevent, detect or investigate any illegal
                  activities related to our Platform. Such disclosure may also
                  be done in order for us to fulfil any legal obligations that
                  may arise. Further, we may share your personal information in
                  order to investigate, defend or take action regarding illegal
                  activities, suspected fraud, situations involving potential
                  threats to the physical safety of any person, or as otherwise
                  required by law.
                </li>
                <li>
                  <strong>Associated business entities:</strong> The Company may
                  share your personal information with its affiliates and group
                  companies for offering relevant products and offers to you. If
                  the Company and its assets are wholly or substantially
                  acquired by a third party in future, customer information will
                  be one of the assets that may be transferred. This transition
                  will take place with full disclosure of this Privacy Policy
                  and the commitments expressed herein.
                </li>
                <li>
                  <strong>Third Party Services:</strong> The Platform may allow
                  you to connect with other websites, products, or services that
                  we don’t have control over (for example, if we allow you to
                  pay through an external wallet facility then we will have to
                  share your usage information with the facility provider).
                  However, usage of such third-party services is subject to
                  their privacy policies and not within our control. We
                  recommend that you have a look at their privacy policies
                  before agreeing to use their services.
                </li>
              </ul>
            </li>
            <li>
              The third parties who work on behalf of Company are subject to
              strict confidentiality agreements. Additionally, they are not
              allowed to share this information with anyone except on a need to
              know basis required for carrying out their functions.
            </li>
          </ol>
          <h5>D. How do we protect your personal information?</h5>
          <p>
            The Company limits access to personal information to authorized
            employees, associates, partners and officers. Additionally, our
            third-party service providers are held to stringent standards of
            privacy and confidentiality. We maintain physical, electronic and
            procedural safeguards to protect the information against loss,
            misuse, damage or modification and unauthorized access or
            disclosure. Some of the other central features of our information
            security program are:
          </p>
          <ol>
            <li>The use of specialized technology such as firewalls.</li>
            <li>
              Testing of the security and operability of products and services
              by the IT department before they are introduced to the internet,
              as well as ongoing scanning for publicly known vulnerabilities in
              the technology.
            </li>
            <li>
              Implementing controls to identify, authenticate and authorize
              access to various systems or sites
            </li>
            <li>
              Restricting use of external data devices on Company’s systems
            </li>
            <li>
              Providing Company’s personnel with relevant training and
              continually updating our security practices in light of new risks
              and developments in technology.
            </li>
            <li>
              However, we cannot guarantee the privacy of personal information
              you transmit over the web or that may not be securely transmitted.
            </li>
          </ol>
          <h5>
            E. What are your rights regarding the personal information collected
            by us?
          </h5>
          <p>
            It is important for us that you remain in control of your personal
            information. If you would like us to modify, delete or withdraw
            consent regarding the use of any personal information collected
            about you, please send an email to with ‘REMOVE’ mentioned in the
            subject line. However, you may not be able to use our Platform at
            all after such deletion or withdrawal of consent.
          </p>
          <h5>F. Data retention</h5>
          <p>
            We shall only retain your personal information to facilitate your
            smooth and uninterrupted use of the Platform. We do not retain your
            personal information for longer than required for the purpose for
            which the information may be lawfully used.
          </p>
          <h5>G. Children’s privacy</h5>
          <p>
            Our Platform is not meant to be used by children, and we do not
            knowingly solicit or collect personal information from persons under
            the age of 18 (eighteen). If we find out that a child has given us
            personal information, we will take steps to delete that information
            and terminate the relevant user account.
          </p>
          <h5>H. Shipping Policy</h5>
          <p>
            Processing Time : All orders are delivered within 2-3 business days.
          </p>
          <h5>I. Grievances</h5>
          <p>
            Should you have any grievances about the processing of your personal
            information, you may contact:
          </p>
          <ul style={{ listStyle: "none" }}>
            <li>Get Trendy</li>
            <li>
              Flat No. 403, 4th Floor, B-wing, Saraswati Crystal Opp. Silver
              Brich Hospital, Raikar Mala, Dhayari, Pune-411041
            </li>
            <li>Email: prashhaant@gmail.com</li>
          </ul>
          <p>
            All email messages sent to and from the Company may be monitored
            with the objective of ensuring compliance with internal policies and
            to protect our business.
          </p>
          <p>
            This document is an electronic record in terms of Information
            Technology Act, 2000 and rules there under as applicable and the
            amended provisions pertaining to electronic records in various
            statutes as amended by the Information Technology Act, 2000. This
            electronic record is generated by a computer system and does not
            require any physical or digital signatures.
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
